import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "control-menu__link",
  role: "button"
}
const _hoisted_2 = { class: "control-menu__sub" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Expandable',
  props: {
    iconClass: {},
    title: {},
    defaultOpen: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const isOpenState = ref(props.defaultOpen)

const toggleState = (): void => {
  isOpenState.value = !isOpenState.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["control-menu__unit control-menu__unit--has-child", {
      'control-menu__unit--has-child--open': isOpenState.value,
    }]),
    onClick: toggleState
  }, [
    _createElementVNode("a", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass([__props.iconClass, "control-menu__icon iconfont"])
      }, null, 2),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(__props.title), 1),
        _createElementVNode("span", {
          class: _normalizeClass([{
            'control-menu__menu-icon-open': isOpenState.value,
          }, "control-menu__menu-icon iconfont isub-menu"])
        }, null, 2)
      ])
    ]),
    _createVNode(_Transition, { name: "toc-submenu" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, isOpenState.value]
        ])
      ]),
      _: 3
    })
  ], 2))
}
}

})